var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.793 21.5864C16.0691 21.5864 16.293 21.8103 16.293 22.0864C16.2927 22.3623 16.069 22.5864 15.793 22.5864H8.79297C8.51702 22.5864 8.29322 22.3623 8.29297 22.0864C8.29297 21.8103 8.51686 21.5864 8.79297 21.5864H15.793ZM15.293 18.5864C15.8453 18.5864 16.293 19.0341 16.293 19.5864C16.2927 20.1385 15.8451 20.5864 15.293 20.5864H9.29297C8.74087 20.5864 8.29322 20.1384 8.29297 19.5864C8.29297 19.0341 8.74072 18.5864 9.29297 18.5864H15.293ZM15.293 14.5864C15.8453 14.5864 16.293 15.0341 16.293 15.5864V16.5864C16.2927 17.1385 15.8451 17.5864 15.293 17.5864H9.29297C8.74087 17.5864 8.29322 17.1384 8.29297 16.5864V15.5864C8.29297 15.0341 8.74072 14.5864 9.29297 14.5864H15.293ZM11.5859 2.29343C11.9765 1.9029 12.6095 1.9029 13 2.29343L20.4395 9.7319C20.7544 10.0468 20.5312 10.5862 20.0859 10.5864H16.293V12.5864C16.2927 13.1385 15.8451 13.5864 15.293 13.5864H9.29297C8.74087 13.5864 8.29322 13.1384 8.29297 12.5864V10.5864H4.5C4.05455 10.5864 3.8315 10.0469 4.14648 9.7319L11.5859 2.29343Z",
    fill: "url(#paint0_linear_538_11640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_11640",
    x1: 12.2929,
    y1: 10.0864,
    x2: 12.2929,
    y2: 22.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A6FF",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedTestIcon);
export default __webpack_public_path__ + "static/media/speed-test-icon.12bdf84f5f5cb038a2f26eead830807d.svg";
export { ForwardRef as ReactComponent };